/**
 * Funcíon que retorna los endpoint de las APIS
 * @nota Si se encesita agregar endpoints a producción se tiene que modificar en el siguiente link, aplicando la misma estructura
 * @see https://console.aws.amazon.com/amplify/home?region=us-east-1#/d87194dpfi06e/settings/variables
 * @returns { apis: { NOMBRE_ENDPOINT: { endpoint: ENDPOINT } } }
 * @author Joel Martinez <joel.martinez@mxmart.mx>
 * @version 1.0 09/07/2021
 */
 export function getAPISMaster() {
	const endpointDev = {
		"apis": {
			"apiAuth":{"endpoint":"https://efxrcappba.execute-api.us-east-1.amazonaws.com/dev/auth"}, //API de dashboardAdministrativo
			"apiCatalogos":{"endpoint": "https://mrccntjyee.execute-api.us-east-1.amazonaws.com/dev"}, //API dashboardAdministrativo
			"getUrlPlataforma": {"endpoint":"https://vxqexd561m.execute-api.us-east-1.amazonaws.com/dev/getUrlPlataforma"}, //API del Campus
			"getAlumnosBloqueados": {"endpoint":"https://66ycsqbjnf.execute-api.us-east-1.amazonaws.com/dev/busquedaAlumnosBloqueados"},
		}
	};
	const endpoints = process.env.REACT_APP_ENDPOINT ? process.env.REACT_APP_ENDPOINT !== "None" ? JSON.parse(process.env.REACT_APP_ENDPOINT) : endpointDev : endpointDev;
	return endpoints;
}
